import React from "react";
import CurrencyFormat from "react-currency-format";
import SizeDropdown from "../../Dropdown/SizeDropdown";
import LegHeightOptions from "./LegHeightOptions";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";

export const BuildingDimensions = ({ params, const_var, heightOptions, isShowLiftReq, isInventoryorNot, changeBuildingDimension, setBuildingFlags, hasDoublelegBaiserail, handleLiftRequired }) => {
	const onWidthChange = (value) => {
		if (params.p_w != value) {
			changeBuildingDimension({ val: value, str: "w", noApiCall: true });
			if (const_var.isForStandardBuilding == true && !const_var.b_o_J_1[params.p_b_t].includes("Free Standing") && !const_var.b_o_J_1[params.p_b_t].includes("RV Covers")) {
				let minHeight = const_var.roof_style.filter((obj) => params.p_r_s == obj.roof_id);

				minHeight = params.singleSlope == true ? minHeight[0].start_height : minHeight[0].min_height;
				if (params.p_h && parseFloat(params.p_h) > parseFloat(value) && minHeight != undefined && parseInt(minHeight) <= parseInt(value)) {
					changeBuildingDimension({ val: value, str: "h" });
				} else {
					changeBuildingDimension({ val: params.p_h, str: "h" });
				}
			} else {
				changeBuildingDimension({ val: params.p_h, str: "h" });
			}
		}
	};
	return (
		<>
			<div className="form-group">
				<div className="control-label-bar">
					<label className="control-label">Width & Length</label>

					<div className="control-label-action">
						{const_var.post_data.building != undefined && const_var.loginSession == true ? (
							<div className="price-box">{const_var.post_data.building != undefined ? <EditPriceItem jsonObj={const_var.post_data.building.roof_style_price} jsonObjKey="roof_style_price" /> : null}</div>
						) : (
							<div className="price-box-type-2">
								{const_var.hide_price_calculation != 1 &&
									const_var.loginSession == false &&
									const_var.post_data.building !== undefined &&
									const_var.post_data.building.roof_style_price !== undefined &&
									const_var.post_data.building.roof_style_price !== 0 && <CurrencyFormat value={const_var.post_data.building.roof_style_price} displayType="text" thousandSeparator={true} prefix="$" />}
							</div>
						)}
					</div>
				</div>

				<div className="floating-label-input floating-input-group">
					<SizeDropdown
						value={params.p_w}
						options={const_var.buildingWidthArray}
						onChange={(value) => {
							onWidthChange(value);
						}}
					/>

					<SizeDropdown
						value={params.p_d}
						options={const_var.buildingLengthArray}
						onChange={(value) => {
							params.p_d != value &&
								changeBuildingDimension({
									val: value,
									str: "l"
								});
						}}
					/>
				</div>
			</div>

			<div className="form-group">
				<div className="control-label-bar justify-content-start">
					<label className="control-label">Height</label>

					<div className="control-label-action">
						{const_var.post_data.building != undefined && const_var.loginSession == true ? (
							<div className="price-box">
								<EditPriceItem jsonObj={const_var.post_data.building.height_price !== undefined ? const_var.post_data.building.height_price : 0} jsonObjKey="height_price" />
							</div>
						) : (
							<div className="price-box-type-2">
								{const_var.hide_price_calculation != 1 &&
									const_var.loginSession == false &&
									const_var.post_data.building !== undefined &&
									const_var.post_data.building.height_price !== undefined &&
									const_var.post_data.building.height_price !== 0 && <CurrencyFormat value={const_var.post_data.building.height_price} displayType="text" thousandSeparator={true} prefix="$" />}
							</div>
						)}
					</div>
				</div>

				<div className="row no-gutters">
					<div className="col-6">
						<div className="floating-label-input">
							<SizeDropdown
								value={const_var.buildingHeightArray.find((val) => val.value == params.p_h)?.value || params.p_h}
								options={const_var.buildingHeightArray}
								onChange={(value) => {
									params.p_h != value &&
										changeBuildingDimension({
											val: value,
											str: "h"
										});
								}}
							/>
						</div>
					</div>
				</div>

				<LegHeightOptions
					params={params}
					const_var={const_var}
					heightOptions={heightOptions}
					isShowLiftReq={isShowLiftReq}
					isInventoryorNot={isInventoryorNot}
					setBuildingFlags={setBuildingFlags}
					hasDoublelegBaiserail={hasDoublelegBaiserail}
					handleLiftRequired={handleLiftRequired}
				/>
			</div>
		</>
	);
};
